import { FormDataType, SchemaDeriveData } from '@/components/DynamicForm/types/DynamicFormTypes';
import { permittedFormDataFns } from '@/components/DynamicForm/utils/functions';
import { path } from '@/components/DynamicForm/utils/utils';
import { OnSubmitPayload } from '@/components/DynamicForm/types/OnSubmitTypes';

export const buildSubmitPayload = (formData: FormDataType, payloadSchema?: OnSubmitPayload): FormDataType => {
	return {
		...payloadSchema,
		...formData,
	};
};

export const formDataChangesFromSchema = (deriveDataList: SchemaDeriveData[], initValue: FormDataType): FormDataType =>
	deriveDataList.reduce(
		(acc: FormDataType, { name = '', fn, selectKeys = [], defaultValue }) =>
			Object.assign(acc, {
				[name]: calculateDerivedFunction(fn, acc, selectKeys) ?? defaultValue,
			}),
		{ ...initValue }
	);

const calculateDerivedFunction = (fn: string, acc: FormDataType, selectKeys: string[]) =>
	permittedFormDataFns[permittedFormDataFns[fn] ? fn : 'default'].apply(
		null,
		selectKeys.map((keyName: string) => path([keyName], acc))
	);
